import { render } from "./popularity.vue?vue&type=template&id=755315b2"
import script from "./popularity.vue?vue&type=script&lang=js"
export * from "./popularity.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__